import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import "slick-carousel/slick/slick.scss";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { ProductReviewsPopup } from "./ProductReviewsPopup";
import { ReviewItem } from "./ReviewItem";
export function ProductReviews(_ref) {
  var reviews = _ref.reviews;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeGallery = _useState2[0],
      setActiveGallery = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      activeGalleryIndex = _useState4[0],
      setActiveGalleryIndex = _useState4[1];

  function showGallery(gallery, index) {
    setActiveGallery(gallery);
    setActiveGalleryIndex(index);
    document.body.classList.add("hidden");
  }

  function _closeGallery() {
    setActiveGallery(null);
    document.body.classList.remove("hidden");
  }

  var showPopup = activeGallery && !!activeGallery.length;
  var sliderSettings = {
    arrows: true,
    autoplaySpeed: 4000,
    centerMode: true,
    centerPadding: "20px",
    infinite: false,
    responsive: [{
      breakpoint: 767,
      settings: {
        adaptiveHeight: true,
        centerPadding: "40px",
        swipe: false
      }
    }],
    slidesToScroll: 1,
    slidesToShow: 1,
    variableWidth: true
  };
  var slider = useRef(null);

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      startPos = _useState6[0],
      setStartPos = _useState6[1];

  var touchStart = function touchStart(e) {
    setStartPos(e.nativeEvent.touches[0].clientX);
  };

  var touchEnd = function touchEnd(e) {
    var endPos = e.nativeEvent.changedTouches[0].clientX;
    var delta = startPos - endPos;
    var minDeltaValue = 25;

    if (Math.abs(delta) > minDeltaValue && delta > 0) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      slider.current.slickNext();
    }

    if (Math.abs(delta) > minDeltaValue && delta < 0) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      slider.current.slickPrev();
    }
  };

  return React.createElement(React.Fragment, null, (reviews === null || reviews === void 0 ? void 0 : reviews.edges.length) >= 1 && React.createElement("div", {
    className: "product-reviews-wr"
  }, showPopup && React.createElement(ProductReviewsPopup, {
    gallery: activeGallery,
    galleryIndex: activeGalleryIndex,
    closeGallery: function closeGallery() {
      _closeGallery();
    }
  }), React.createElement("div", {
    className: "product-reviews"
  }, React.createElement("div", {
    className: "container"
  }, React.createElement("div", {
    className: "product-reviews__content"
  }, React.createElement("div", {
    className: "page-title-wr padding-left container"
  }, React.createElement("h2", {
    className: "page-title"
  }, "What customers are saying")))), React.createElement("div", {
    className: "product-reviews__slider-wr"
  }, React.createElement("div", {
    className: "product-reviews__slider"
  }, (reviews === null || reviews === void 0 ? void 0 : reviews.edges.length) === 1 ? React.createElement("div", {
    className: "container"
  }, React.createElement(ReviewItem, {
    item: reviews === null || reviews === void 0 ? void 0 : reviews.edges[0].node,
    showGallery: showGallery
  })) : React.createElement("div", {
    onTouchStart: function onTouchStart(e) {
      return touchStart(e);
    },
    onTouchEnd: function onTouchEnd(e) {
      return touchEnd(e);
    }
  }, React.createElement(Slider, _extends({}, sliderSettings, {
    ref: slider
  }), reviews === null || reviews === void 0 ? void 0 : reviews.edges.map(function (e, i) {
    return React.createElement("div", {
      className: "product-reviews__slide",
      key: "".concat(e.node.title, "-").concat(i)
    }, React.createElement(ReviewItem, {
      item: e.node,
      showGallery: showGallery
    }));
  }))), React.createElement("div", {
    className: "product-reviews__link-wr"
  }, React.createElement(Link, {
    className: "product-reviews__link",
    to: "/"
  }, "View all reviews")))))));
}